module.exports = __webpack_public_path__ + "908bfbaa3cbb3710d78955c5aa1c0824.MP3";